import { render, staticRenderFns } from "./DashboardAi.vue?vue&type=template&id=557ddf92&scoped=true"
import script from "./DashboardAi.vue?vue&type=script&lang=js"
export * from "./DashboardAi.vue?vue&type=script&lang=js"
import style0 from "./DashboardAi.vue?vue&type=style&index=0&id=557ddf92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557ddf92",
  null
  
)

export default component.exports